<template>
  <section class="content checkout-content wp_AllPageMarginTop wp_MarginBottomAllPage">
    <!-- progress tracker -->
    <!-- <div class="progrs-trckr-contain"> -->
    <div class="tracking-page">
      <div class="progrs-trckr-contain mx-auto">
        <div class="tracking-details-top">
          <p
            v-if="orders&& orders.customer_details && orders.customer_details.phoneNumber && getScreenWidth > 992"
            style="min-height: 21px;"
            data-test="orderTrackingPara"
            id="orderTrackingPara"
          ></p>
        </div>
        <span
          class="tracker-ordr-top"
          id="order-track-no-head"
          data-test="orderTrackingOrderNo"
        >Order No: {{(queryParameter+'').toUpperCase()}}</span>
        <!-- <order-product :orderProducts="od.orderProductDetails">
        </order-product>-->
        <div>
          <div class="row" v-for="(order,key) in orders.orderProductDetails" :key="key" v-show="orders && orders.orderProductDetails">
            <div class="col-md-2 col-sm-6">
              <div class="tracker-left-img">
                <img
                  v-if="order.product_image"
                  :src="order.product_image"
                  :alt="order.product_name"
                  :id="'order-track-img-'+key"
                  :data-test="'orderTrackingOrderPdtImg'+key"
                />
                <img
                  v-else
                  src="/img/icons/noImage.jpg"
                  :alt="order.product_name"
                  :id="'order-track-img-'+key"
                  :data-test="'orderTrackingNoPdtImg'+key"
                />
              </div>
            </div>
            <div class="col-md-2 col-sm-6 tracking-product-item">
              <router-link
                :id="'order-track-name-'+key"
                :to="{
																name: 'ProductDetails',
																query: {
																	productId: order.product_id,
																	productName: order.product_name
																}
															}"
                :data-test="'orderTrackingPdtName'+key"
              >{{order.product_name}}</router-link>
              <br />
              <small
                :id="'order-track-price-'+key"
                :data-test="'orderTrackingPdtPrice'+key"
              >Price: {{ order.price | currencyConversion}}</small>
              <br />
              <small
                :id="'order-track-qty-'+key"
                :data-test="'orderTrackingPdtQty'+key"
              >Quantity: {{order.quantity}}</small>
              <br />
              <small
                :id="'order-track-qty-'+key"
                :data-test="'orderTrackingPdtSubTotal'+key"
              >Total: {{order.sub_total | currencyConversion}}</small>
              <br />
              <small
                :id="'order-track-url-'+key"
                v-if="order.tracking_id"
                :data-test="'orderTrackingPdtTrack'+key"
              >
                <a
                  :href="'https://www.tpcindia.com/TPCWebService/tracktracejson.ashx?podno='+order.tracking_id"
                  :data-test="'orderTrackingPdtTrackLink'+key"
                  :id="'orderTrackingPdtTrackLink'+key"
                >Track this Product</a>
              </small>
            </div>
            <!-- <div class="col-md-6 col-sm-10">
            <ul class="progress-tracker progress-tracker--text progress-tracker--center">
              <li class="progress-step is-complete">
                <span class="progress-marker" :id="'progress-marker-1-'+key"></span>
                <span class="progress-text" :id="'progress-text-1-'+key">
                  <h6 class="progress-title" :id="'progress-title-1-'+key">Ordered</h6>
                  {{new Date(order.order_date).toLocaleDateString()}}
                </span>
              </li>
              <li class="progress-step" :class="{'is-complete':(order.is_progressed)}">
                <span class="progress-marker" :id="'progress-marker-2-'+key"></span>
                <span class="progress-text" :id="'progress-text-2-'+key">
                  <h6 class="progress-title" :id="'progress-title-2-'+key">Processing</h6>
                  <span
                    v-if="order.shipped_date"
                    :id="'progress-packed-2-'+key"
                  >{{new Date(order.order_date).toLocaleDateString()}}</span>
                </span>
              </li>
              <li class="progress-step" :class="{'is-complete':order.is_shipped}">
                <span class="progress-marker" :id="'progress-marker-3-'+key"></span>
                <span class="progress-text" :id="'progress-text-3-'+key">
                  <h6 class="progress-title" :id="'progress-title-3-'+key">Shipped</h6>
                  <span
                    v-if="order.shipped_date"
                    :id="'progress-shipped-3-'+key"
                  >{{new Date(order.shipped_date).toLocaleDateString()}}</span>
                </span>
              </li>

              <li
                class="progress-step"
                :class="{'is-complete':order.order_status}"
                v-if="order.order_status === 'Delivered'"
              >
                <span class="progress-marker" :id="'progress-marker-4-'+key"></span>
                <span class="progress-text" :id="'progress-text-4-'+key">
                  <h6 class="progress-title" :id="'progress-title-4-'+key">Delivered</h6>
                  <span
                    v-if="order.order_status &&
                  order.order_status === 'Delivered' &&
                  order.shipped_date"
                    :id="'progress-delivery-4-'+key"
                  >{{new Date(order.delivered_date).toLocaleDateString()}}</span>
                </span>
              </li>

              <li class="progress-step" :class="{'is-complete':order.is_delivered}" v-else>
                <span class="progress-marker" :id="'progress-marker-5-'+key"></span>
                <span class="progress-text" :id="'progress-text-5-'+key">
                  <h6 class="progress-title" :id="'progress-isdelivered-5-'+key">Delivered</h6>
                </span>
              </li>
            </ul>
            </div>-->
            <div class="col-md-5 col-sm-10 progress-track-wrapper">
              <ul class="progress-tracker progress-tracker--text progress-tracker--center">
                <li
                  class="progress-step is-complete"
                  :data-test="'orderTrackingprogressComplete'+key"
                  :id="'orderTrackingprogressComplete'+key"
                >
                  <span
                    class="progress-marker"
                    :id="'progress-marker-1-'+key"
                    :data-test="'orderTrackingprogressMarker1'+key"
                  ></span>
                  <span
                    class="progress-text"
                    :id="'progress-text-1-'+key"
                    :data-test="'orderTrackingOrderedSpan'+key"
                  >
                    <h6
                      class="progress-title"
                      :id="'progress-title-1-'+key"
                      :data-test="'orderTrackingOrderedTitle'+key"
                    >Ordered</h6>
                    <span
                      class="progress-date"
                      :data-test="'orderTrackingOrderDate'+key"
                      :id="'orderTrackingOrderDate'+key"
                    >{{dateFormatting(order.order_date)}}</span>
                  </span>
                </li>
                <li
                  class="progress-step"
                  :class="{'is-complete':(order.order_status === 'Processing' | order.order_status === 'Shipped' | order.order_status === 'Delivered')}"
                  :data-test="'orderTrackingprogressProcessingComplete'+key"
                  :id="'orderTrackingprogressProcessingComplete'+key"
                >
                  <span
                    class="progress-marker"
                    :id="'progress-marker-2-'+key"
                    :data-test="'orderTrackingprogressMarker2'+key"
                  ></span>
                  <span
                    class="progress-text"
                    :id="'progress-text-2-'+key"
                    :data-test="'orderTrackingProcessingSpan'+key"
                  >
                    <h6
                      class="progress-title"
                      :id="'progress-title-2-'+key"
                      :data-test="'orderTrackingProcessingTitle'+key"
                    >Processing</h6>
                    <span
                      class="progress-date"
                      v-if="order.shipped_date"
                      :id="'progress-packed-2-'+key"
                      :data-test="'orderTrackingProcessingDate'+key"
                    >{{dateFormatting(order.shipped_date)}}</span>
                  </span>
                </li>
                <li
                  class="progress-step"
                  :class="{'is-complete':(order.order_status === 'Shipped' | order.order_status === 'Delivered')}"
                  :data-test="'orderTrackingprogressShippedComplete'+key"
                  :id="'orderTrackingprogressShippedComplete'+key"
                >
                  <span
                    class="progress-marker"
                    :id="'progress-marker-3-'+key"
                    :data-test="'orderTrackingprogressMarker3'+key"
                  ></span>
                  <span
                    class="progress-text"
                    :id="'progress-text-3-'+key"
                    :data-test="'orderTrackingShippedSpan'+key"
                  >
                    <h6
                      class="progress-title"
                      :id="'progress-title-3-'+key"
                      :data-test="'orderTrackingShippedTitle'+key"
                    >Shipped</h6>
                    <span
                      class="progress-date"
                      v-if="order.shipped_date"
                      :id="'progress-shipped-3-'+key"
                      :data-test="'orderTrackingShippedDate'+key"
                    >{{dateFormatting(order.shipped_date)}}</span>
                  </span>
                </li>

                <li
                  class="progress-step"
                  :class="{'is-complete':order.order_status}"
                  v-if="order.order_status === 'Delivered'"
                  :data-test="'orderTrackingprogressDeliveredComplete'+key"
                  :id="'orderTrackingprogressDeliveredComplete'+key"
                >
                  <span
                    class="progress-marker"
                    :id="'progress-marker-4-'+key"
                    :data-test="'orderTrackingprogressMarker4'+key"
                  ></span>
                  <span
                    class="progress-text"
                    :id="'progress-text-4-'+key"
                    :data-test="'orderTrackingDeliveredSpan'+key"
                  >
                    <h6
                      class="progress-title"
                      :id="'progress-title-4-'+key"
                      :data-test="'orderTrackingDeliveredTitle'+key"
                    >Delivered</h6>
                    <span
                      class="progress-date"
                      v-if="order.order_status &&
                  order.order_status === 'Delivered' &&
                  order.shipped_date"
                      :id="'progress-delivery-4-'+key"
                      :data-test="'orderTrackingDeliveredDate'+key"
                    >{{dateFormatting(order.delivered_date)}}</span>
                  </span>
                </li>

                <li
                  class="progress-step"
                  :class="{'is-complete':order.is_delivered}"
                  :data-test="'orderTrackingprogressElseDeliveredComplete'+key"
                  :id="'orderTrackingprogressElseDeliveredComplete'+key"
                  v-else
                >
                  <span
                    class="progress-marker"
                    :id="'progress-marker-5-'+key"
                    :data-test="'orderTrackingprogressMarker5'+key"
                  ></span>
                  <span
                    class="progress-text"
                    :id="'progress-text-5-'+key"
                    :data-test="'orderTrackingElseDeliveredSpan'+key"
                  >
                    <h6
                      class="progress-title"
                      :id="'progress-isdelivered-5-'+key"
                      :data-test="'orderTrackingElseDeliveredTitle'+key"
                    >Delivered</h6>
                  </span>
                </li>
              </ul>
            </div>
            <div
              class="col-md-2 col-sm-2 d-flex flex-column justify-content-center align-items-center"
            >
              <button
                class="btn btn-sm blue-btn rate-btn-track"
                @click="orderRating(order)"
                style="width: 110px"
                v-if="order.order_status === 'Delivered'"
                :id="'rate-review-btn-'+key"
                :data-test="'orderTrackingRateReviewBtn'+key"
              >Rate & Review</button>
              <!--Exclude feature: Return-->

              <!--<button-->
              <!--class="btn btn-sm blue-btn rate-btn-track mt-2"-->
              <!--style="width: 110px"-->
              <!--@click="orderReturn(order)"-->
              <!--v-if="order.order_status === 'Delivered'"-->
              <!--:id="'return-btn-'+key"-->
              <!--&gt;Return</button>-->

              <!--Exclude feature: Return-->
            </div>
          </div>
          <hr />
          <div class="row" v-if="transactionStatus">
            <div class="col-12 m-2">
              <h6
                class="transaction-deatils"
                data-test="orderTrackingTrasanctionStatusHead"
                id="orderTrackingTrasanctionStatusHead"
              >Transaction Status: {{transactionStatus}}</h6>
            </div>
          </div>
          <hr v-if="orders.applied_coupon_amount" />
          <div class="row" v-if="orders.applied_coupon_amount">
            <div class="col-12 m-2">
              <h6
                class="transaction-deatils"
                data-test="orderTrackingCouponAmtHead"
                id="orderTrackingCouponAmtHead"
              >Coupon Discount: {{orders.applied_coupon_amount}}</h6>
            </div>
          </div>
          <hr v-if="orders.gift_card_amount" />
          <div class="row" v-if="orders.gift_card_amount">
            <div class="col-12 m-2">
              <h6
                class="transaction-deatils"
                data-test="orderTrackingGiftCardAmtHead"
                id="orderTrackingGiftCardAmtHead"
              >Gift Card Discount: {{orders.gift_card_amount}}</h6>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12 m-2">
              <h6
                class="transaction-deatils"
                v-if="orders.shipping_charge"
                data-test="orderTrackingShippingHead"
                id="orderTrackingShippingHead"
              >Shipping Charge: {{orders.shipping_charge | currencyConversion}}</h6>
              <h6
                class="transaction-deatils"
                v-if="orders.tax"
                data-test="orderTrackingTaxHead"
                id="orderTrackingTaxHead"
              >Tax Charge: {{orders.tax | currencyConversion}}</h6>
              <h6
                class="transaction-deatils"
                style="font-size: 1.0em;     font-weight: 700;"
                data-test="orderTrackingTotalAmtHead"
                id="orderTrackingTotalAmtHead"
              >Total Amount Paid: {{orders.total_amount_to_pay | currencyConversion}}</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="shipping-details">
        <p class="uu" data-test="orderTrackingShippingDetailsHead">Shipping Details</p>
        <div
          class="address"
          v-if="orders.customer_details&&
             orders.customer_details.customerAddress"
        >
          <p
            class="username"
            v-if="orders.customer_details.customerAddress.firstname &&
             orders.customer_details.customerAddress.lastname"
            data-test="orderTrackingNameHead"
            id="orderTrackingNameHead"
          >{{orders.customer_details.customerAddress.firstname+' '+orders.customer_details.customerAddress.lastname}}</p>
          <p
            v-if="orders.customer_details.customerAddress.addresslineone &&
          orders.customer_details.customerAddress.addresslinetwo"
            data-test="orderTrackingAddressHead"
            id="orderTrackingAddressHead"
          >
            {{orders.customer_details.customerAddress.addresslineone}} ,
            {{orders.customer_details.customerAddress.addresslinetwo}} ,
          </p>
          <p
            v-if="orders.customer_details.customerAddress.place"
            data-test="orderTrackingPlaceHead"
            id="orderTrackingPlaceHead"
          >{{orders.customer_details.customerAddress.place}} ,</p>
          <p
            v-if="orders.customer_details.customerAddress.locality"
            data-test="orderTrackingLocalityHead"
            id="orderTrackingLocalityHead"
          >{{orders.customer_details.customerAddress.locality}} ,</p>
          <p
            v-if="orders.customer_details.customerAddress.state"
            data-test="orderTrackingStateHead"
            id="orderTrackingStateHead"
          >
            {{orders.customer_details.customerAddress.state}} -
            <span
              v-if="orders.customer_details.customerAddress.pincode"
              data-test="orderTrackingPincodeHead"
              id="orderTrackingPincodeHead"
            >{{orders.customer_details.customerAddress.pincode}}</span>
          </p>
          <p
            v-if="orders.customer_details.customerAddress.country"
            data-test="orderTrackingCountryHead"
            id="orderTrackingCountryHead"
          >{{orders.customer_details.customerAddress.country}}.</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { orderApi } from '@/services/ApiServices/orderApi'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
	data () {
		return {
			orders: Object,
			queryParameter: '',
			transactionStatus: ''
		}
	},
	beforeMount () {
		if (this.$route.query.token) {
			if (this.isAuthenticated) {
				orderApi
					.trackOrder(this.$route.query.orderNumber, this.$route.query.token)
					.then(res => {
						if (res.data) {
							const order = {
								orderProductDetails: []
							}
							//
							order.orderProductDetails.push(res.data)
							this.orders = order
							//
							this.queryParameter = this.$route.query.orderNumber
						}
					})
					.catch()
			} else {
				// $('#login-modal').modal('show');
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'orderTracking'
					}
				})
			}
		} else if (this.isAuthenticated) {
			orderApi.getOrders().then(res => {
				if (res.body) {
					this.orders = JSON.parse(
						JSON.stringify(res.body.orderHistory)
					).filter(
						orderProduct => this.queryParameter === orderProduct.order_number
					)
					if (this.orders && this.orders[0]) {
						this.orders = this.orders[0]
						if (
							this.orders &&
              this.orders.orderProductDetails &&
              this.orders.orderProductDetails[0] &&
              this.orders.orderProductDetails[0].shipping_method
						) {
							this.transactionStatus = this.orders.orderProductDetails[0].payment_status
						}
					}
				} else {
					this.orders = []
				}
			})
			this.queryParameter = this.$route.query.orderNumber
		} else {
			//   $('#login-modal')
			// .modal('show');
			this.$router.push({
				path: '/login',
				query: {
					next_to: 'previous'
				}
			})
		}
	},
	computed: {
		orderProducts () {
			if (this.orders && this.orders.length > 0) {
				return this.orders.filter(
					orderProduct => this.queryParameter === orderProduct.order_number
				)
			}
			return []
		},
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('siteData', ['getScreenWidth'])
	},
	methods: {
		orderRating (order) {
			this.$router.push({
				path: '/user/orders/orderRating',
				query: {
					orderProductId: order.product_id,
					orderVendorId: order.vendor_id
				}
			})
		},
		orderReturn (order) {
			this.$router.push({
				path: '/user/orders/orderReturn',
				query: {
					orderProductId: order.product_id,
					orderVendorId: order.vendor_id,
					orderNumber: this.queryParameter
				}
			})
			// this.$router.push({
			//   path: '/user/orders/orderRating',
			//   query: { orderData: order.product_id },
			// });
		},
		dateFormatting (d) {
			const a = moment(d).format('MMM Do YYYY')
			return a
		},
		progresstrack () {
			// let step = 'step1'
			// const step1 = document.getElementById('step1')
			// const step2 = document.getElementById('step2')
			// const step3 = document.getElementById('step3')
			// const step4 = document.getElementById('step4')
			// function next () {
			// 	if (step === 'step1') {
			// 		step = 'step2'
			// 		step1.classList.remove('is-active')
			// 		step1.classList.add('is-complete')
			// 		step2.classList.add('is-active')
			// 	} else if (step === 'step2') {
			// 		step = 'step3'
			// 		step2.classList.remove('is-active')
			// 		step2.classList.add('is-complete')
			// 		step3.classList.add('is-active')
			// 	} else if (step === 'step3') {
			// 		step = 'step4d'
			// 		step3.classList.remove('is-active')
			// 		step3.classList.add('is-complete')
			// 		step4.classList.add('is-active')
			// 	} else if (step === 'step4d') {
			// 		step = 'complete'
			// 		step4.classList.remove('is-active')
			// 		step4.classList.add('is-complete')
			// 	} else if (step === 'complete') {
			// 		step = 'step1'
			// 		step4.classList.remove('is-complete')
			// 		step3.classList.remove('is-complete')
			// 		step2.classList.remove('is-complete')
			// 		step1.classList.remove('is-complete')
			// 		step1.classList.add('is-active')
			// 	}
			// }
		}
	},
	mounted () {
		this.progresstrack()
		// const a = moment('2019-05-22').format('MMM Do YYYY')
	}
}
</script>
